module.exports = __webpack_public_path__ + "img/max-office-building-repeat.b466c4e3.svg";